import apiCaller from '@/api/index';
import {GetCouponListRequest} from '@/models/request/couponRequestModel';

export async function getNftIdListByLinkApi(link: string) {
  const response = await apiCaller.get(
    "/access_links/:link/nfts/ids",
    { params: { link } },
    {}
  );
  return response.data;
}

export async function getNftDetailWithLinkApi(nftId: string, link: string) {
  const response = await apiCaller.get(
    "/access_links/:link/nfts/:id",
    { params: { id: nftId, link } },
    {}
  );
  return response.data;
}

export async function postGenerateQRDataByLinkApi(nftId: string, link: string) {
  const response = await apiCaller.post(
    "/access_links/:link/nfts/:id/qr",
    {
      params: { id: nftId, link },
    },
    {}
  );
  return response.data;
}

export async function getNftStatusByLinkApi(nftId: string, link: string) {
  const response = await apiCaller.get(
    "/access_links/:link/nfts/:id/status",
    { params: { id: nftId, link } },
    {}
  );
  return response.data;
}

export async function getNftSeatByLinkApi(nftId: string, link: string) {
  const response = await apiCaller.get(
    "/access_links/:link/nfts/:id/seat",
    { params: { id: nftId, link } },
    {}
  );
  return response.data;
}

export async function getCouponListByLinkApi(request: GetCouponListRequest) {
  const response = await apiCaller.get("/access_links/:link/coupons", { query: request, params: { link: request.accessLink } }, {});
  return response.data;
}

export async function getCouponDetailByLinkApi(couponId: string, accessLink: string) {
  const response = await apiCaller.get(
    "/access_links/:link/coupons/:id",
    { params: { id: couponId, link: accessLink } },
    {}
  );
  return response.data;
}

export async function postGenerateCouponQrOrPinByLinkApi(couponId: string, accessLink: string) {
  const response = await apiCaller.post(
    "/access_links/:link/coupons/:id/qr",
    { params: { id: couponId,  link: accessLink } },
    {}
  );
  return response.data;
}

export async function getCouponStatusByLinkApi(couponId: string, accessLink: string) {
  const response = await apiCaller.get(
    "/access_links/:link/coupons/:id/status",
    { params: { id: couponId,  link: accessLink } },
    {}
  );
  return response.data;
}
